import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";

/**
 * Guard for inventory / recipes / food-cost pages.
 * Requires the user to have at least one of `requiredModules` enabled on
 * their tenant. Falls back to a friendly notice when missing.
 */
export default function InventoryModuleGuard({ requiredModules, children }) {
  const { t } = useTranslation();
  const { tenant, checking } = useAuth();

  if (checking) {
    return (
      <div className="surface-card p-12 text-center text-[#475569]">
        {t("restaurant.common.loading")}
      </div>
    );
  }

  const enabled = tenant?.enabled_modules || [];
  const ok = requiredModules.some((m) => enabled.includes(m));

  if (!ok) {
    return (
      <div className="surface-card p-12 text-center text-[#475569]" data-testid="inv-blocked">
        {t("restaurant.common.module_required")}
      </div>
    );
  }
  return children;
}
